import { render, staticRenderFns } from "./tenants.vue?vue&type=template&id=1af96721"
import script from "./tenants.ts?vue&type=script&lang=js&external"
export * from "./tenants.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports